export default __webpack_public_path__ + "static/media/146.bc5ccd6e.gif";